import { createFileRoute } from "@tanstack/react-router";
import { EventDetailPage } from "@/features/event-explorer/components/EventDetailPage";

export const Route = createFileRoute("/event-search/$event-id")({
  component: EventDetailPage,
  loader: ({ params }) => {
    return { eventId: params["event-id"] };
  },
});
